import MaterialTablePagination from "../../../../../__snowpack__/pkg/@mui/material/TablePagination.js";
import styled from "styled-components";
export const PaginationContainer = styled(MaterialTablePagination).withConfig({
  displayName: "table-paginationstyles__PaginationContainer",
  componentId: "sc-sjgzw0-0"
})(["", ""], {
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))"
});
